import React, { useState } from "react";
import PopupForm from "./PopupForm.js"; // Import the Popup Form
import "./CallAnalytics.css";

const CallAnalytics = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className="call-analytics-container">
      {/* Hero Section */}
      <section className="hero-call-section">
        <div className="hero-content">
          <h1>Call Analytics</h1>
          <p>
            Analyze call data, monitor trends, and enhance customer interactions.
          </p>
          <button className="cta-button" onClick={() => setIsPopupOpen(true)}>
            Connect Now!
          </button>
        </div>
      </section>

       {/* About Call Analytics */}
       <section className="about-call-section">
        <div className="about-content">
        <div className="vector-image">
            <img 
              src="./call-img.png" 
              alt="Big Data Vector" 
            />
          </div>
          <div className="about-text">
            <h2>What is Call Analytics?</h2>
            <p>
              Call Analytics provides data-driven insights from customer interactions to improve call center performance, enhance customer satisfaction, and optimize sales strategies.
            </p>
            <ul>
              <li>🔹 Call Tracking & Monitoring</li>
              <li>🔹 Speech & Sentiment Analysis</li>
              <li>🔹 AI-driven Insights & Automation</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <h2 className="section-title">Why Choose Our Call Analytics Solution?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">📞</span>
            <h3>Call Tracking</h3>
            <p>Monitor and analyze call data in real time.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📊</span>
            <h3>Performance Insights</h3>
            <p>Identify trends and optimize communication strategies.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🎯</span>
            <h3>Customer Engagement</h3>
            <p>Enhance user experience with AI-driven analytics.</p>
          </div>
        </div>
      </section>

      {/* Popup Form Component */}
      <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default CallAnalytics;



